import * as jose from "jose";
import { getPrivateKeyOrNull } from "./cryptoKeys";

export function looksLikeCompactJWE(v) {
  if (typeof v !== "string") return false;
  const parts = v.split(".");
  return parts.length === 5 && parts.every((p) => p.length > 0);
}

export async function decryptCompactJwe(jwe) {
  const pk = getPrivateKeyOrNull();
  if (!pk) throw new Error("NO_PRIVATE_KEY");
  const { plaintext } = await jose.compactDecrypt(jwe, pk);
  return JSON.parse(new TextDecoder().decode(plaintext));
}
